<template>
  <div class="aro">
    <div v-if="['pending', 'running'].includes(status)" class="aro-box">
      <div class="aro-note">{{ status === 'pending' ? 'Queued' : 'Running' }}…</div>
      <pre v-if="consoleText" class="aro-console sensitive" data-demo-blur>{{ consoleText }}</pre>
    </div>
    <div v-else-if="status === 'failed'" class="aro-box aro-error sensitive" data-demo-blur>{{ error || 'R analysis failed.' }}</div>
    <div v-else-if="!outputs.length" class="aro-box aro-note">The run completed without outputs.</div>
    <template v-else>
      <div v-for="(output, j) in outputs" :key="`${output.kind}-${output.name}-${j}`" class="aro-output">
        <div class="aro-label"><span class="aro-kind">{{ output.kind }}</span> · {{ output.name }}</div>
        <div v-if="output.kind === 'effect'" class="aro-facts">
          <div class="aro-fact"><div class="aro-fact-k">Estimate</div><div class="aro-fact-v ae-mono">{{ output.estimate }}</div></div>
          <div class="aro-fact"><div class="aro-fact-k">95% CI</div><div class="aro-fact-v ae-mono">{{ output.ci_low }} to {{ output.ci_high }}</div></div>
          <div class="aro-fact"><div class="aro-fact-k">p</div><div class="aro-fact-v ae-mono">{{ output.p }}</div></div>
          <div class="aro-fact"><div class="aro-fact-k">Unit</div><div class="aro-fact-v">{{ output.unit }}</div></div>
          <div class="aro-fact" style="grid-column: span 2"><div class="aro-fact-k">Model</div><div class="aro-fact-v">{{ output.model }}</div></div>
        </div>
        <div v-else-if="output.kind === 'table'" class="aro-table-scroll sensitive">
          <table class="aro-table">
            <thead><tr><th v-for="c in columnsOf(output.rows)" :key="c">{{ c }}</th></tr></thead>
            <tbody>
              <tr v-for="(r, ri) in output.rows" :key="ri"><td v-for="c in columnsOf(output.rows)" :key="c">{{ r[c] }}</td></tr>
            </tbody>
          </table>
        </div>
        <div v-else-if="output.kind === 'plot'" class="aro-box sensitive">
          <img v-if="plotUrls[plotKey(output)]" :src="plotUrls[plotKey(output)]" :alt="output.name" class="aro-plot" />
          <div v-else class="aro-note">Loading plot…</div>
        </div>
        <div v-else class="aro-box sensitive" data-demo-blur>{{ output.detail }}</div>
        <div v-if="output.caption" class="aro-note sensitive" data-demo-blur>{{ output.caption }}</div>
      </div>
    </template>
  </div>
</template>

<script>
export function plotKey(output) {
  return output.file || output.path || `plots/${output.name}.png`;
}

export default {
  name: 'AgentRunOutput',
  props: {
    status: { type: String, default: '' },
    error: { type: String, default: '' },
    consoleText: { type: String, default: '' },
    outputs: { type: Array, default: () => [] },
    plotUrls: { type: Object, default: () => ({}) },
  },
  methods: {
    plotKey,
    columnsOf(rows) {
      return Object.keys((rows || [])[0] || {});
    },
  },
};
</script>

<style scoped>
.aro { display: flex; flex-direction: column; gap: 10px; min-width: 0; }
.aro-box { border: 1px solid #E8E9E9; border-radius: 6px; padding: 10px 12px; min-width: 0; }
.aro-error { color: #D53D3D; }
.aro-note { font-size: 12px; color: #8E8F90; }
.aro-console { margin: 8px 0 0; background: #FAFAFA; color: #353537; border: 1px solid #E8E9E9; border-radius: 6px; padding: 10px 12px; font-family: 'IBM Plex Mono', 'JetBrains Mono', monospace; font-size: 11.5px; line-height: 1.5; white-space: pre-wrap; max-height: 200px; overflow: auto; }
.aro-output { display: flex; flex-direction: column; gap: 6px; }
.aro-label { font-size: 11px; color: #626264; text-transform: uppercase; letter-spacing: 0.04em; }
.aro-kind { color: #8E8F90; }
.aro-facts { display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 12px; border: 1px solid #E8E9E9; border-radius: 6px; padding: 10px 12px; }
.aro-fact { display: flex; flex-direction: column; gap: 2px; min-width: 0; }
.aro-fact-k { font-size: 11px; color: #626264; text-transform: uppercase; letter-spacing: 0.04em; }
.aro-fact-v { font-size: 13px; color: #1E1F21; font-weight: 500; overflow-wrap: anywhere; }
.aro-table-scroll { border: 1px solid #E8E9E9; border-radius: 6px; max-height: 320px; overflow: auto; }
.aro-table { width: 100%; border-collapse: collapse; font-size: 12px; }
.aro-table th { text-align: left; font-weight: 600; color: #626264; padding: 5px 10px; border-bottom: 1px solid #E8E9E9; background: #FAFAFA; font-size: 11px; white-space: nowrap; }
.aro-table td { padding: 4px 10px; border-bottom: 1px solid #F4F4F4; color: #353537; }
.aro-table tbody tr:last-child td { border-bottom: 0; }
.aro-plot { max-width: 100%; display: block; }
</style>
